@if (!hideField) {
<span>
  @if (radioButtonFormGroup) {
  <form [formGroup]="radioButtonFormGroup">
    <mat-label
      class="color-dark-blue"
      id="{{ question.uniqueHtmlIdentifier }}"
      >{{ question.question.caption }}</mat-label
    >
    @if (question.question.isRequired) {
    <mat-label class="color-city-red"> *</mat-label>
    }
    <div>
      <mat-radio-group
        aria-labelledby="radio-group-label"
        [(ngModel)]="question.answer"
        formControlName="radioButtonGroup"
      >
        @for (option of question.question.additionalPropertiesParsed.Options;
        track option; let indexOfelement = $index) {
        <div>
          <mat-radio-button
            (change)="onOptionSelected($event)"
            [value]="option"
            [checked]="question.answer && question.answer == option"
            id="questionOption{{ question.uniqueHtmlIdentifier }}{{
              indexOfelement
            }}"
          >
            @if (question.question.additionalPropertiesParsed.OptionsDescription
            == null) {
            <div>
              <mat-label class="font-size-body-text city-teal-dark">
                {{ option }}
              </mat-label>
            </div>
            } @if
            (question.question.additionalPropertiesParsed.OptionsDescription !=
            null) {
            <div>
              <mat-label class="city-teal-dark">
                {{
                  question.question.additionalPropertiesParsed
                    .OptionsDescription[indexOfelement] != null &&
                  question.question.additionalPropertiesParsed
                    .OptionsDescription[indexOfelement].length > 0
                    ? question.question.additionalPropertiesParsed
                        .OptionsDescription[indexOfelement]
                    : option
                }}
              </mat-label>
            </div>
            }
          </mat-radio-button>
        </div>
        }
      </mat-radio-group>
      @if (question.question.isRequired && !(question.answer)) {
      <mat-error>{{ "radiobutton_required" | translate }}</mat-error>
      }
    </div>
  </form>
  }
</span>
}
